window.initScrollLinks = () => {

  var scroll_links = document.querySelectorAll('a.smooth-scroll');

  if (scroll_links.length > 0) scroll_links.forEach(link => {
    if(link.classList.contains('smooth-scroll-enabled')) return;

    link.addEventListener('click', (e) => {
      link.classList.add('smooth-scroll-enabled');

      console.log('navigator.userAgent', navigator)

      e.preventDefault();
  
      var element = document.querySelector(e.target.closest('a.smooth-scroll').getAttribute('href'));
      var headerOffset = document.querySelector('sticky-header').offsetHeight;
  
      if (element) {

        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset - 15; 
        
        console.log('elementPosition', elementPosition, offsetPosition)

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });

        setTimeout(() => {
          element.focus();
        }, 500);
  
      }
    });
  });
}

window.initScrollLinks();


window.addEventListener('DOMContentLoaded', (event) => {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search);

  if (params.has('page')) {
    // Scroll the body to the ProductGridContainer
    const headerHeight = document.querySelector('header').offsetHeight;
    const ProductGridContainer = document.getElementById('ProductGridContainer');
    const productCount = document.querySelector('.product-grid-container .product-count__text');

    console.log('productCOUNT', productCount);

    if(ProductGridContainer){
      window.scroll({
        top: ProductGridContainer.offsetTop - headerHeight - 32,
        behavior: 'smooth'
      });

      productCount.focus(); 
    } 
  }

  if(params.has('login_success')){
    updateCart();
  }

});

async function getCart() {
  return fetch(`/cart.js`).then((response) => {
    return response.json();
  });
}

async function asyncForEach(array, callback) {
  for (const item of array) {
    await callback(item);
  }
}

async function updateCart(){
  var cart_items = document.querySelector('cart-items');
  if(cart_items){
    var cart = await getCart();

    if(cart.items.length > 0){
      var line = 1;
      await asyncForEach(cart.items, async (item) => {
        cart_items.updateQuantity(line, item.quantity)
        line++;
      });
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {

  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  if(elementToFocus.classList.contains('no-focus')) return;

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.changeInfo = this.querySelector('.quantity-info');

  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.input.textContent = `Quantity: ${this.input.value}`;
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if(event.target.name === 'plus'){
      this.input.stepUp();
      this.changeInfo.innerText = `Quantity Increased: ${this.input.value}`;
    } else {
      this.input.stepDown();
      this.changeInfo.innerText = `Quantity Decreased: ${this.input.value}`;
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.mainSummary = this.mainDetailsToggle.querySelector('summary');
    this.search = this.querySelector('.search__input');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    });
    
    if(this.closest('header')){
      var button = this.closest('header').querySelector('button.header__icon--open-search');
      if(button) {
        button.addEventListener('click', this.onSearchClick.bind(this))
        button.addEventListener('touchstart', this.onSearchClick.bind(this))
      }
    }
    
    this.querySelectorAll(
      'button:not(.header__icon--open-search):not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.search__button):not(.reset__button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSearchClick(event) {

    this.mainDetailsToggle.open = true
    this.openMenuDrawer(this.mainSummary);
  
    setTimeout(() => {
      this.search.focus();
      this.search.click();
    }, 500);

  }

  onSummaryClick(event) {

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details:not(.details-sale)').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    var summaries = this.querySelectorAll('summary.menu-drawer__menu-item');
    if(summaries.length > 0) {
      summaries.forEach(summary => {
        summary.addEventListener('click', (event) => {
          var clicked_summary = event.target.closest('summary');
          summaries.forEach(summary => {
            if(summary.id !== clicked_summary.id){
              summary.parentElement.removeAttribute('open')
            }
          });
        });
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.enableSliderLooping = true;
    this.enableInfiniteLoop = this.dataset.enableInfiniteLoop === 'true';
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]:not(.slider-button-absolute)');
    this.nextButton = this.querySelector('button[name="next"]:not(.slider-button-absolute)');
    this.prevButtonAbsolute = this.querySelector('button[name="previous"].slider-button-absolute');
    this.nextButtonAbsolute = this.querySelector('button[name="next"].slider-button-absolute');

    if (!this.slider) return;
    
    // Infinite loop state
    this.isRepositioning = false;
    this.originalSlideCount = 0;
    this.cloneCount = 0;
    this.clonesActive = false;
    
    // Detect if this is a thumbnail gallery slider
    this.isThumbnailGallery = this.classList.contains('thumbnail-slider') || 
                               this.closest('media-gallery') !== null;

    // Drag state
    this.isDragging = false;
    this.shouldClick = true;
    this.dragStartX = undefined;
    this.dragStartY = undefined;
    this.scrollStart = undefined;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    
    // Add scrollend listener for infinite loop repositioning
    if (this.enableInfiniteLoop) {
      // Modern browsers support 'scrollend' event
      if ('onscrollend' in window) {
        this.slider.addEventListener('scrollend', this.checkAndReposition.bind(this));
      } else {
        // Fallback for older browsers - use debounced scroll
        let scrollTimeout;
        this.slider.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => this.checkAndReposition(), 150);
        });
      }
    }
    
    if (this.prevButton) this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.nextButton) this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.prevButtonAbsolute) this.prevButtonAbsolute.addEventListener('click', this.onButtonClick.bind(this));
    if (this.nextButtonAbsolute) this.nextButtonAbsolute.addEventListener('click', this.onButtonClick.bind(this));

    // Add click handlers for dots/numbers navigation - handle both desktop and mobile links
    const allSliderLinks = this.querySelectorAll('.slider-counter__link');
    allSliderLinks.forEach((link) => link.addEventListener('click', this.linkToPage.bind(this)));
    
    // Add mouse drag functionality
    // this.initDragHandlers();
  }

  initDragHandlers() {
    // Click handler - checks shouldClick flag (Slick.js pattern)
    this.slider.addEventListener(
      'click',
      (e) => {
        if (this.shouldClick === false) {
          e.stopImmediatePropagation();
          e.stopPropagation();
          e.preventDefault();
        }
      },
      true
    ); // Use capture to ensure we catch it first

    // Mouse down - start tracking potential drag
    this.slider.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return; // Only left mouse button

      // Store initial mouse position and scroll position
      this.dragStartX = e.pageX;
      this.dragStartY = e.pageY;
      this.scrollStart = this.slider.scrollLeft;

      // Reset flags
      this.shouldClick = true;
      this.isDragging = false;

      // Attach listeners
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
    });
  }

  onDragMove = (e) => {
    if (!this.dragStartX) return;

    // Calculate distance moved from initial position
    const deltaX = e.pageX - this.dragStartX;
    const deltaY = e.pageY - this.dragStartY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

    // If not dragging yet, check if we've moved enough to start
    if (!this.isDragging) {
      if (distance > 5) {
        this.isDragging = true;
        this.shouldClick = false;
        this.slider.classList.add('slider--dragging');
        this.slider.style.cursor = 'grabbing';
        this.slider.style.userSelect = 'none';
      } else {
        return; // Not enough movement yet
      }
    }

    // Perform the drag - apply the delta to the initial scroll position
    e.preventDefault();
    this.slider.scrollLeft = this.scrollStart - deltaX;
  };

  onDragEnd = (e) => {
    // Remove listeners
    document.removeEventListener('mousemove', this.onDragMove);
    document.removeEventListener('mouseup', this.onDragEnd);

    // Clean up styles
    if (this.isDragging) {
      this.slider.classList.remove('slider--dragging');
      this.slider.style.cursor = '';
      this.slider.style.userSelect = '';
    }

    // Reset state
    const wasDragging = this.isDragging;
    this.isDragging = false;
    this.dragStartX = undefined;
    this.dragStartY = undefined;
    this.scrollStart = undefined;

    // Reset shouldClick after a brief delay to allow click event to process
    // Only reset if we weren't dragging (if we were dragging, shouldClick is already false)
    if (!wasDragging) {
      setTimeout(() => {
        this.shouldClick = true;
      }, 0);
    } else {
      // If we were dragging, reset immediately
      setTimeout(() => {
        this.shouldClick = true;
      }, 10);
    }
  };

  setupInfiniteLoop() {
    if (!this.slider || !this.enableInfiniteLoop) return;
    
    // Store original slides before cloning (exclude any existing clones)
    const originalSlides = Array.from(this.slider.querySelectorAll('[id^="Slide-"]:not(.clone)'));
    
    // Only update originalSlideCount if it hasn't been set yet
    if (this.originalSlideCount === 0) {
      this.originalSlideCount = originalSlides.length;
    }
    
    if (this.originalSlideCount < 2) return;
    
    // Check viewport and slider classes to determine if we should add clones
    const isDesktop = window.innerWidth >= 750;
    const hasDesktopSlider = this.slider.classList.contains('slider--desktop');
    const hasTabletSlider = this.slider.classList.contains('slider--tablet');
    
    // Only add clones if:
    // - On desktop and has slider--desktop class, OR
    // - On mobile and has slider--tablet class
    const shouldAddClones = (isDesktop && hasDesktopSlider) || (!isDesktop && hasTabletSlider);
    
    if (!shouldAddClones) {
      // Don't add clones, but still set originalSlideCount
      return;
    }
    
    // Calculate how many clones we need based on visible columns
    // We want enough clones to ensure smooth scrolling even when scrolling quickly
    const columnsDesktop = parseInt(this.dataset.columnsDesktop) || 4;
    const columnsMobile = parseInt(this.dataset.columnsMobile) || 2;
    const maxColumns = Math.max(columnsDesktop, columnsMobile);
    
    // Clone 2x the visible columns on each side for buffer
    this.cloneCount = Math.min(maxColumns * 2, this.originalSlideCount);
    
    // Add clones at the end (first slides repeated)
    for (let i = 0; i < this.cloneCount; i++) {
      const clone = originalSlides[i % this.originalSlideCount].cloneNode(true);
      clone.classList.add('clone', 'clone-end');
      clone.removeAttribute('id'); // Remove IDs to avoid duplicates
      this.slider.appendChild(clone);
    }
    
    // Add clones at the beginning (last slides repeated)
    for (let i = 0; i < this.cloneCount; i++) {
      const sourceIndex = this.originalSlideCount - 1 - (i % this.originalSlideCount);
      const clone = originalSlides[sourceIndex].cloneNode(true);
      clone.classList.add('clone', 'clone-start');
      clone.removeAttribute('id'); // Remove IDs to avoid duplicates
      this.slider.insertBefore(clone, this.slider.firstChild);
    }
    
    // Mark that clones are now active
    this.clonesActive = true;
    
    // Update sliderItems to include clones for calculations
    this.sliderItems = this.querySelectorAll('[id^="Slide-"], .clone');
  }
  
  removeClones() {
    if (!this.slider) return;
    
    // Remove all clone elements
    const clones = this.slider.querySelectorAll('.clone');
    clones.forEach(clone => clone.remove());
    
    // Reset state
    this.clonesActive = false;
    this.cloneCount = 0;
    
    // Reset sliderItems to original slides only
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    
    // Reset scroll position to start
    this.slider.scrollTo({ left: 0, behavior: 'instant' });
  }
  
  shouldClonesBeActive() {
    if (!this.slider || !this.enableInfiniteLoop) return false;
    
    const isDesktop = window.innerWidth >= 750;
    const hasDesktopSlider = this.slider.classList.contains('slider--desktop');
    const hasTabletSlider = this.slider.classList.contains('slider--tablet');
    
    // Only add clones if:
    // - On desktop and has slider--desktop class, OR
    // - On mobile and has slider--tablet class
    return (isDesktop && hasDesktopSlider) || (!isDesktop && hasTabletSlider);
  }
  
  positionToFirstRealSlide() {
    // Position to first real slide after sliderItemOffset has been calculated
    if (!this.enableInfiniteLoop || !this.sliderItemOffset) return;
    
    // Scroll to the first real slide (after the prepended clones) without animation
    const firstRealSlideOffset = this.cloneCount * this.sliderItemOffset;
    
    // Use requestAnimationFrame to ensure layout is complete before scrolling
    requestAnimationFrame(() => {
      this.slider.scrollTo({ left: firstRealSlideOffset, behavior: 'instant' });
      // Force an update after positioning to ensure correct page is calculated
      requestAnimationFrame(() => {
        this.update();
      });
    });
  }

  checkAndReposition() {
    if (!this.enableInfiniteLoop || this.isRepositioning || !this.sliderItemOffset) return;
    
    const scrollLeft = this.slider.scrollLeft;
    const slideIndex = Math.round(scrollLeft / this.sliderItemOffset);
    
    // Calculate boundaries
    const firstRealSlideIndex = this.cloneCount;
    const lastRealSlideIndex = this.cloneCount + this.originalSlideCount - 1;
    
    // Check if we're viewing clones at the start
    if (slideIndex < firstRealSlideIndex) {
      this.isRepositioning = true;
      
      // Calculate how far into the clone zone we are
      const offsetIntoClones = firstRealSlideIndex - slideIndex;
      
      // Jump to the equivalent position at the end
      const newScrollPosition = (this.cloneCount + this.originalSlideCount - offsetIntoClones) * this.sliderItemOffset;
      
      this.slider.scrollTo({ left: newScrollPosition, behavior: 'instant' });
      
      setTimeout(() => { this.isRepositioning = false; }, 50);
    }
    // Check if we're viewing clones at the end
    else if (slideIndex > lastRealSlideIndex) {
      this.isRepositioning = true;
      
      // Calculate how far into the clone zone we are
      const offsetIntoClones = slideIndex - lastRealSlideIndex;
      
      // Jump to the equivalent position at the start
      const newScrollPosition = (this.cloneCount + offsetIntoClones - 1) * this.sliderItemOffset;
      
      this.slider.scrollTo({ left: newScrollPosition, behavior: 'instant' });
      
      setTimeout(() => { this.isRepositioning = false; }, 50);
    }
  }

  initPages() {
    const mediaQuery = window.matchMedia('(min-width: 750px)');
    this.verticalSlider = this.classList.contains('vertical-media-gallery') && mediaQuery.matches;

    // Update slider control links array reference
    // Query both desktop and mobile counters separately
    const desktopCounter = this.querySelector('.slider-counter.small-hide');
    const mobileCounter = this.querySelector('.slider-counter.medium-hide');
    
    if (desktopCounter) {
      this.desktopSliderControlLinks = Array.from(desktopCounter.querySelectorAll('.slider-counter__link'));
    } else {
      this.desktopSliderControlLinks = [];
    }
    
    if (mobileCounter) {
      this.mobileSliderControlLinks = Array.from(mobileCounter.querySelectorAll('.slider-counter__link'));
    } else {
      this.mobileSliderControlLinks = [];
    }
    
    // Set the active array based on viewport (will be updated in update() method)
    this.sliderControlLinksArray = mediaQuery.matches ? this.desktopSliderControlLinks : this.mobileSliderControlLinks;

    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;

    if (this.verticalSlider) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      // Calculate slidesPerPage - use Math.round for more accurate calculation
      // This helps when the calculation is close to a whole number (e.g., 4.8 should round to 5, not 4)
      const calculatedSlidesPerPage =
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset;
      let calculatedSlides = Math.max(1, Math.round(calculatedSlidesPerPage));

      // Use data attributes as fallback/validation if available
      // Check if we're on desktop or mobile based on window width
      const isDesktop = window.innerWidth >= 750;
      const expectedColumns = isDesktop
        ? this.dataset.columnsDesktop
          ? parseInt(this.dataset.columnsDesktop)
          : null
        : this.dataset.columnsMobile
        ? parseInt(this.dataset.columnsMobile)
        : null;

      // If we have expected columns and calculated value is close, use expected value
      // This helps when calculation is slightly off due to padding/margins
      if (expectedColumns && Math.abs(calculatedSlides - expectedColumns) <= 1) {
        this.slidesPerPage = expectedColumns;
      } else {
        this.slidesPerPage = calculatedSlides;
      }
    }

    // Handle infinite loop setup and dynamic clone management
    if (this.enableInfiniteLoop) {
      // First time initialization
      if (this.originalSlideCount === 0) {
        this.setupInfiniteLoop();
        
        if (this.clonesActive) {
          // Recalculate sliderItemsToShow after adding clones
          this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
          
          // Recalculate sliderItemOffset after adding clones
          if (!this.verticalSlider && this.sliderItemsToShow.length >= 2) {
            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
          }
          
          // Now position to the first real slide
          requestAnimationFrame(() => {
            this.positionToFirstRealSlide();
          });
        }
      } 
      // On resize, check if clone state needs to change
      else {
        const shouldHaveClones = this.shouldClonesBeActive();
        
        // If state changed, update clones
        if (shouldHaveClones && !this.clonesActive) {
          // Need to add clones
          this.setupInfiniteLoop();
          
          // Recalculate sliderItemsToShow after adding clones
          this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
          
          // Recalculate sliderItemOffset after adding clones
          if (!this.verticalSlider && this.sliderItemsToShow.length >= 2) {
            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
          }
          
          // Position to the first real slide
          requestAnimationFrame(() => {
            this.positionToFirstRealSlide();
          });
        } else if (!shouldHaveClones && this.clonesActive) {
          // Need to remove clones
          this.removeClones();
          
          // Recalculate sliderItemsToShow after removing clones
          this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
          
          // Recalculate sliderItemOffset after removing clones
          if (!this.verticalSlider && this.sliderItemsToShow.length >= 2) {
            this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
          }
        }
      }
    }
    
    // Calculate total pages
    const totalItems = this.enableInfiniteLoop ? this.originalSlideCount : this.sliderItemsToShow.length;
    
    if (this.verticalSlider) {
      // For vertical sliders, each item is a "page"
      this.totalPages = Math.max(1, totalItems - this.slidesPerPage + 1);
    } else {
      // For horizontal sliders: total pages = how many "views" are needed to see all items
      // If showing N items at a time from M total items: ceil(M / N)
      // Example: 25 items, 4 per page = ceil(25/4) = ceil(6.25) = 7 pages
      this.totalPages = Math.ceil(totalItems / this.slidesPerPage);
    }
    
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    
    if (this.verticalSlider) {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    } else {
      // Calculate current page based on pages (groups of columns), not individual slides
      let scrollPositionInSlides = this.slider.scrollLeft / this.sliderItemOffset;
      
      // For infinite loop, adjust for clones
      if (this.enableInfiniteLoop && this.originalSlideCount > 0) {
        // Subtract the clone offset to get position relative to real slides
        // Round to nearest integer first to handle floating point precision issues
        const adjustedSlideIndex = Math.round(scrollPositionInSlides) - this.cloneCount;
        
        // Map to real slide index using modulo
        let realSlideIndex = ((adjustedSlideIndex % this.originalSlideCount) + this.originalSlideCount) % this.originalSlideCount;
        
        // Ensure we're within valid bounds (0 to originalSlideCount - 1)
        if (realSlideIndex < 0) realSlideIndex = 0;
        if (realSlideIndex >= this.originalSlideCount) realSlideIndex = this.originalSlideCount - 1;
        
        // Calculate which page we're on
        const calculatedPage = Math.floor(realSlideIndex / this.slidesPerPage) + 1;
        this.currentPage = Math.max(1, Math.min(calculatedPage, this.totalPages));
        
      } else {
        // Standard (non-infinite) calculation
        // Check if we're at or near the end of scrollable content
        const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
        const isNearEnd = Math.abs(this.slider.scrollLeft - maxScrollLeft) < 10; // 10px tolerance
        
        if (isNearEnd) {
          // If we're at the end, we're on the last page
          this.currentPage = this.totalPages;
          console.log('[update] Standard - near end, currentPage:', this.currentPage);
        } else {
          // Use Math.round instead of floor to be more forgiving with sub-pixel rendering
          const calculatedPage = Math.round(scrollPositionInSlides / this.slidesPerPage) + 1;
          // Clamp to valid page range
          this.currentPage = Math.max(1, Math.min(calculatedPage, this.totalPages));
        }
      }
    }

    // Determine which set of slider control links to use based on viewport
    const isDesktopView = window.innerWidth >= 750;
    this.sliderControlLinksArray = isDesktopView ? this.desktopSliderControlLinks : this.mobileSliderControlLinks;

    // Update both desktop and mobile counter text elements
    const desktopCounter = this.querySelector('.slider-counter.small-hide');
    const mobileCounter = this.querySelector('.slider-counter.medium-hide');
    
    if (desktopCounter) {
      const desktopCurrentPage = desktopCounter.querySelector('.slider-counter--current');
      const desktopTotalPage = desktopCounter.querySelector('.slider-counter--total');
      if (desktopCurrentPage) desktopCurrentPage.textContent = this.currentPage;
      if (desktopTotalPage) desktopTotalPage.textContent = this.totalPages;
    }
    
    if (mobileCounter) {
      const mobileCurrentPage = mobileCounter.querySelector('.slider-counter--current');
      const mobileTotalPage = mobileCounter.querySelector('.slider-counter--total');
      if (mobileCurrentPage) mobileCurrentPage.textContent = this.currentPage;
      if (mobileTotalPage) mobileTotalPage.textContent = this.totalPages;
    }

    // Update dots/numbers navigation active state for the active viewport
    if (this.sliderControlLinksArray && this.sliderControlLinksArray.length > 0) {
      this.sliderControlLinksArray.forEach((link, index) => {
        if (index === this.currentPage - 1) {
          link.classList.add('slider-counter__link--active');
          link.setAttribute('aria-current', 'true');
        } else {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        }
      });
    } else {
      // console.log('No sliderControlLinksArray to update!', this.sliderControlLinksArray);
    }

    if (this.currentPage != previousPage) {
      const currentEl = this.sliderItemsToShow[this.currentPage - 1];
      const scrollLeft = this.slider ? this.slider.scrollLeft : null;
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: currentEl,
          },
        })
      );
    }

    // For infinite loop or regular looping, keep buttons always enabled
    if (this.enableSliderLooping || this.enableInfiniteLoop) return;
    // Thumbnail gallery on mobile is infinite (wrap in navigateThumbnail), so keep buttons enabled
    if (this.isThumbnailGallery && window.innerWidth < 750) return;

    const scrollPosition = this.verticalSlider ? this.slider.scrollTop : this.slider.scrollLeft;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && scrollPosition === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
      if (this.prevButtonAbsolute) this.prevButtonAbsolute.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
      if (this.prevButtonAbsolute) this.prevButtonAbsolute.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
      if (this.nextButtonAbsolute) this.nextButtonAbsolute.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
      if (this.nextButtonAbsolute) this.nextButtonAbsolute.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (this.verticalSlider) {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    } else {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  navigateThumbnail(direction) {
    // Find currently active thumbnail (has aria-current="true")
    const activeThumbnail = this.slider.querySelector('[aria-current="true"]');
    if (!activeThumbnail) return;

    // Disable prev/next until this navigation completes to prevent glitchy rapid clicks
    this.setThumbnailButtonsDisabled(true);

    // Get the parent list item
    const currentItem = activeThumbnail.closest('[data-target]');
    if (!currentItem) {
      this.setThumbnailButtonsDisabled(false);
      return;
    }

    // Get all visible thumbnail items (skip hidden variant thumbnails)
    const allItems = Array.from(this.slider.querySelectorAll('[data-target]'));
    const visibleItems = allItems.filter((el) => el.clientWidth > 0 && el.offsetParent !== null);
    if (visibleItems.length === 0) {
      this.setThumbnailButtonsDisabled(false);
      return;
    }

    // Find next/previous visible thumbnail
    let targetItem = direction === 'next'
      ? currentItem.nextElementSibling
      : currentItem.previousElementSibling;
    while (targetItem && (targetItem.clientWidth === 0 || targetItem.offsetParent === null)) {
      targetItem = direction === 'next'
        ? targetItem.nextElementSibling
        : targetItem.previousElementSibling;
    }

    // Infinite on mobile: wrap to first or last visible when at end
    if (!targetItem) {
      const currentIndex = visibleItems.indexOf(currentItem);
      if (direction === 'next') {
        targetItem = visibleItems[(currentIndex + 1) % visibleItems.length];
      } else {
        targetItem = visibleItems[(currentIndex - 1 + visibleItems.length) % visibleItems.length];
      }
    }

    if (!targetItem) {
      this.setThumbnailButtonsDisabled(false);
      return;
    }

    // Click the thumbnail button to activate it
    const button = targetItem.querySelector('button');
    if (button) button.click();

    // Scroll to position the active thumbnail, then re-enable buttons after transition
    const slider = this.slider;
    setTimeout(() => {
      const sliderRect = slider.getBoundingClientRect();
      const itemRect = targetItem.getBoundingClientRect();

      if (this.verticalSlider) {
        const scrollOffset = itemRect.top - sliderRect.top + slider.scrollTop - 1;
        slider.scrollTo({ top: scrollOffset, behavior: 'smooth' });
      } else {
        const scrollOffset = itemRect.left - sliderRect.left + slider.scrollLeft - 1;
        slider.scrollTo({ left: scrollOffset, behavior: 'smooth' });
      }

      // Re-enable buttons after scroll animation completes (~400ms)
      setTimeout(() => {
        this.setThumbnailButtonsDisabled(false);
        this.update();
      }, 450);
    }, 50);
  }

  setThumbnailButtonsDisabled(disabled) {
    if (disabled) {
      this.prevButton?.setAttribute('disabled', 'disabled');
      this.nextButton?.setAttribute('disabled', 'disabled');
      this.prevButtonAbsolute?.setAttribute('disabled', 'disabled');
      this.nextButtonAbsolute?.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton?.removeAttribute('disabled');
      this.nextButton?.removeAttribute('disabled');
      this.prevButtonAbsolute?.removeAttribute('disabled');
      this.nextButtonAbsolute?.removeAttribute('disabled');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    
    // Special handling for thumbnail galleries
    if (this.isThumbnailGallery) {
      this.navigateThumbnail(event.currentTarget.name);
      return;
    }
    
    // Scroll by pages (number of visible columns), not individual slides
    const step = event.currentTarget.dataset.step || this.slidesPerPage;

    if (this.verticalSlider) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    } else {
      // For infinite loop, just scroll normally - clones handle the seamless transition
      if (this.enableInfiniteLoop) {
        this.slideScrollPosition =
          event.currentTarget.name === 'next'
            ? this.slider.scrollLeft + step * this.sliderItemOffset
            : this.slider.scrollLeft - step * this.sliderItemOffset;
      }
      // Handle jump-back looping logic if enabled (but not infinite loop)
      else if (this.enableSliderLooping) {
        const isAtStart = this.currentPage === 1;
        const isAtEnd = this.currentPage === this.totalPages;
        
        if (event.currentTarget.name === 'next') {
          if (isAtEnd) {
            // Loop back to start
            this.slideScrollPosition = 0;
          } else {
            this.slideScrollPosition = this.slider.scrollLeft + step * this.sliderItemOffset;
          }
        } else {
          if (isAtStart) {
            // Loop to end
            this.slideScrollPosition = (this.totalPages - 1) * this.slidesPerPage * this.sliderItemOffset;
          } else {
            this.slideScrollPosition = this.slider.scrollLeft - step * this.sliderItemOffset;
          }
        }
      } else {
        this.slideScrollPosition =
          event.currentTarget.name === 'next'
            ? this.slider.scrollLeft + step * this.sliderItemOffset
            : this.slider.scrollLeft - step * this.sliderItemOffset;
      }
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.verticalSlider) {
      this.slider.scrollTo({
        top: position,
        behavior: 'smooth',
      });
    } else {
      this.slider.scrollTo({
        left: position,
        behavior: 'smooth',
      });
    }
    // Don't call update() here - the scroll event listener will handle it
    // as the smooth scroll animation progresses and completes
  }

  linkToPage(event) {
    event.preventDefault();
    
    // Check which array contains the clicked link
    let targetPage = -1;
    
    if (this.desktopSliderControlLinks && this.desktopSliderControlLinks.includes(event.currentTarget)) {
      targetPage = this.desktopSliderControlLinks.indexOf(event.currentTarget) + 1;
    } else if (this.mobileSliderControlLinks && this.mobileSliderControlLinks.includes(event.currentTarget)) {
      targetPage = this.mobileSliderControlLinks.indexOf(event.currentTarget) + 1;
    }
    
    if (targetPage === -1) return;
    
    console.log('[linkToPage] Clicked dot/page:', targetPage);
    console.log('[linkToPage] Current page before scroll:', this.currentPage);
    console.log('[linkToPage] Total pages:', this.totalPages);
    console.log('[linkToPage] Enable infinite loop:', this.enableInfiniteLoop);
    console.log('[linkToPage] Clone count:', this.cloneCount);
    console.log('[linkToPage] Slides per page:', this.slidesPerPage);
    console.log('[linkToPage] Original slide count:', this.originalSlideCount);
    console.log('[linkToPage] Slider items to show length:', this.sliderItemsToShow.length);
    console.log('[linkToPage] Current scrollLeft:', this.slider.scrollLeft);
    
    if (this.verticalSlider) {
      // For vertical slider, calculate position based on individual items
      const targetScrollPosition = (targetPage - 1) * this.sliderItemOffset;
      console.log('[linkToPage] Vertical - target scroll position:', targetScrollPosition);
      this.setSlidePosition(targetScrollPosition);
    } else {
      // For horizontal slider, calculate position based on pages
      let targetScrollPosition;
      
      if (this.enableInfiniteLoop) {
        // For infinite loop, calculate position within the real slides (accounting for clones)
        // targetPage is 1-indexed, so page 1 = slide index 0, page 2 = slide index slidesPerPage, etc.
        const targetSlideIndex = (targetPage - 1) * this.slidesPerPage;
        // Find the target slide element (accounting for clones)
        // The first real slide is at index cloneCount in sliderItemsToShow
        const firstRealSlideIndex = this.cloneCount;
        const targetElementIndex = firstRealSlideIndex + targetSlideIndex;
        
        console.log('[linkToPage] Infinite loop - targetSlideIndex:', targetSlideIndex);
        console.log('[linkToPage] Infinite loop - firstRealSlideIndex:', firstRealSlideIndex);
        console.log('[linkToPage] Infinite loop - targetElementIndex:', targetElementIndex);
        
        // Use the actual slide element's offsetLeft for precise positioning
        if (this.sliderItemsToShow[targetElementIndex]) {
          targetScrollPosition = this.sliderItemsToShow[targetElementIndex].offsetLeft;
          console.log('[linkToPage] Infinite loop - using element offsetLeft:', targetScrollPosition);
        } else {
          // Fallback to calculation if element not found
          targetScrollPosition = Math.round((this.cloneCount + targetSlideIndex) * this.sliderItemOffset);
          console.log('[linkToPage] Infinite loop - fallback calculation:', targetScrollPosition);
        }
      } else if (targetPage === this.totalPages) {
        // For the last page, scroll to show the remaining items
        // Position should be: (totalItems - slidesPerPage) * itemOffset
        targetScrollPosition = Math.round((this.sliderItemsToShow.length - this.slidesPerPage) * this.sliderItemOffset);
        console.log('[linkToPage] Last page - target scroll position:', targetScrollPosition);
      } else {
        // For other pages, scroll by full page increments
        targetScrollPosition = Math.round((targetPage - 1) * this.slidesPerPage * this.sliderItemOffset);
        console.log('[linkToPage] Standard - target scroll position:', targetScrollPosition);
      }
      
      console.log('[linkToPage] Final target scroll position:', targetScrollPosition);
      this.setSlidePosition(targetScrollPosition);
    }
  }

}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    // Handle separate desktop and mobile slider control links
    const desktopCounter = this.querySelector('.slider-counter.small-hide');
    const mobileCounter = this.querySelector('.slider-counter.medium-hide');
    
    if (desktopCounter) {
      this.desktopSliderControlLinks = Array.from(desktopCounter.querySelectorAll('.slider-counter__link'));
      this.desktopSliderControlLinks.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    } else if (this.sliderControlWrapper) {
      // Fallback for slideshows that don't have separate desktop/mobile counters
      this.desktopSliderControlLinks = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.desktopSliderControlLinks.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    } else {
      this.desktopSliderControlLinks = [];
    }
    
    if (mobileCounter) {
      this.mobileSliderControlLinks = Array.from(mobileCounter.querySelectorAll('.slider-counter__link'));
      this.mobileSliderControlLinks.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    } else {
      this.mobileSliderControlLinks = [];
    }
    
    // Set the initial array
    const mediaQuery = window.matchMedia('(min-width: 750px)');
    this.sliderControlLinksArray = mediaQuery.matches ? this.desktopSliderControlLinks : this.mobileSliderControlLinks;
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    
    // Use the same logic as parent class to determine which links to update
    const isDesktopView = window.innerWidth >= 750;
    this.sliderControlButtons = isDesktopView ? this.desktopSliderControlLinks : this.mobileSliderControlLinks;
    
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons || !this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    
    if (this.sliderControlButtons[this.currentPage - 1]) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    
    // Check which array contains the clicked link
    let linkIndex = -1;
    
    if (this.desktopSliderControlLinks && this.desktopSliderControlLinks.includes(event.currentTarget)) {
      linkIndex = this.desktopSliderControlLinks.indexOf(event.currentTarget);
    } else if (this.mobileSliderControlLinks && this.mobileSliderControlLinks.includes(event.currentTarget)) {
      linkIndex = this.mobileSliderControlLinks.indexOf(event.currentTarget);
    }
    
    if (linkIndex === -1) return; // Link not found in either array
    
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (linkIndex + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

/* Custom Functions */

class DocumentsComponent extends HTMLElement {
  constructor() {
    super();

    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';

    this.slides = this.querySelectorAll('.slider__slide');
    if(this.slides.length > 0){
      this.pdfs = Array.from(this.slides).map(slide => {
        return {
          pdf_url: slide.dataset.pdfUrl,
          canvas_id: `pdf-canvas-${slide.dataset.index}`
        }
      });

      if(this.pdfs.length > 0){
        this.pdfs.forEach(pdf => this.loadPDFThumbnail(pdf.pdf_url, pdf.canvas_id));
      }

    }
  }

  loadPDFThumbnail(pdfUrl, canvasId) {
    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    
    loadingTask.promise.then(pdf => {
      // Get the first page
      pdf.getPage(1).then(page => {
        const scale = 1.5;  // Scale for the image quality
        const viewport = page.getViewport({ scale });
        
        const canvas = document.getElementById(canvasId);
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
  
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };
  
        page.render(renderContext).promise.then(() => {
          console.log('Thumbnail rendered for ' + canvasId);
        });
      });
    }).catch(err => {
      console.error('Error loading PDF: ' + err);
    });
  }

}

customElements.define('documents-component', DocumentsComponent);


class PDFCanvas extends HTMLElement {
  constructor() {
    super();

    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';

    this.pdfUrl = this.dataset.pdfUrl;
    this.canvasId = this.dataset.canvasId;
  }

  connectedCallback() {
    this.loadPDFThumbnail(this.pdfUrl, this.canvasId);
  }

  loadPDFThumbnail(pdfUrl, canvasId) {

    const loadingTask = pdfjsLib.getDocument(pdfUrl);
    
    loadingTask.promise.then(pdf => {
      // Get the first page
      pdf.getPage(1).then(page => {
        const scale = 1.5;  // Scale for the image quality
        const viewport = page.getViewport({ scale });
        
        const canvas = document.getElementById(canvasId);
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
  
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };
  
        page.render(renderContext).promise.then(() => {
          console.log('Thumbnail rendered for ' + canvasId);
        });
      });
    }).catch(err => {
      console.error('Error loading PDF: ' + err);
    });
  }

}

customElements.define('pdf-canvas', PDFCanvas);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabButtons = this.querySelectorAll(".product-tab");
    const contents = this.querySelectorAll(".tab-content");

    if(tabButtons.length > 1){
      tabButtons.forEach(tab => {
        tab.addEventListener('click', (event) => {

          event.preventDefault();
          const target = event.target;

          const id = target.getAttribute('href');

          if (id) {
            tabButtons.forEach(tab => tab.classList.remove('active'));
            target.classList.add("active");

            contents.forEach(content => content.classList.remove('active'));
            this.querySelector(id).classList.add("active")

            var slideshow = this.querySelector('slider-component');
            if(slideshow) slideshow.slickRefresh();

          }

        });
      });
    }

    if(contents.length > 0){
      contents.forEach(content => {

        var content_area = content.querySelector('.metafield-rich_text_field');
        if(!content_area) return;
        const childNodes = content_area.childNodes;

        // Create a new div element
        const hiddenDiv = document.createElement('div');
        hiddenDiv.classList.add('extra-content')
        hiddenDiv.style.display = 'none';

        let shouldMove = false;
    
        // Loop through child nodes
        for (let i = 0; i < childNodes.length; i++) {
            if (shouldMove) {
                // Clone the child node and append it to the hidden div
                hiddenDiv.appendChild(childNodes[i].cloneNode(true));
                // Remove the original child node
                content_area.removeChild(childNodes[i]);
                // Decrement the counter since we removed a node
                i--;
            }
            // Check if we have moved past the first two nodes
            if (!shouldMove && i > 1) {
                shouldMove = true;
            }
        }
        
        // Append the hidden div after the content area
        content_area.parentNode.insertBefore(hiddenDiv, content_area.nextSibling);

        var read_more = content.querySelector('.read-more');
        if (read_more) {
          // Hide the read more link if hiddenDiv is empty
          if (hiddenDiv.textContent.trim() === '') {
              read_more.style.display = 'none';
          }
      
          read_more.addEventListener('click', (event) => {
              // Toggle display of the hidden div
              if (hiddenDiv.style.display === 'none') {
                  hiddenDiv.style.display = 'block';
                  read_more.textContent = 'Read Less';
              } else {
                  hiddenDiv.style.display = 'none';
                  read_more.textContent = 'Read More';
              }

              trapFocus(read_more.closest('.product-tab-content'), read_more.closest('.product-tab-content').querySelector('.tab-content'));

          });
      }
      });
    }
  }
}

customElements.define('product-tabs', ProductTabs);

class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Attach click event listener to the button
    this.querySelector('button').addEventListener('click', () => {
      this.scrollToTop();
    });

    // Hide or show the button based on scroll position
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        this.style.display = 'block';
      } else {
        this.style.display = 'none';
      }
    });
  }

  // Function to smoothly scroll to the top
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('back-to-top', BackToTop);

class SaleSwitch extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', (evt) => {
      // Retrieve the URLs from dataset attributes
      const collectionUrl = this.dataset.collection;
      const collectionSaleUrl = this.dataset.collectionSale;

      var url = new URL(window.location.href);

      // Check if the checkbox is checked
      if (evt.target.checked) {
        // Navigate to collectionSaleUrl if checked
        setTimeout(() => {
          window.location.href = collectionSaleUrl + url.search;
        }, 300);
      } else {
        setTimeout(() => {
          window.location.href = collectionUrl + url.search;
        }, 300);
      }
    });
  }

}

customElements.define('sale-switch', SaleSwitch);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

  }

  async asyncForEach(array, callback) {
    for (const item of array) {
      await callback(item);
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if(!event.target.closest('.cart-items')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  renderContents(parsedState){

    this.getSectionsToRender().forEach((section) => {

      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
        var getSectionInnerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );

      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

  }

  updateQuantity(line, quantity, name, variantId) {

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {

          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            
            var getSectionInnerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          // cartDrawerWrapper
          //   ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          //   : lineItem.querySelector(`[name="${name}"]`).focus();

            document.querySelector('.drawer__heading').focus()

        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {

         

          document.querySelector('.drawer__heading').focus()

          // trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      })
      .catch((e) => {
        console.log('ERROR', e)
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        window.ci_view_cart_click();
        window.begin_checkout_button_click();
      });
  }

  updateLiveRegions(line, message) {

    const lineItemError = document.getElementById(`Line-item-error-${line}`)
    const lineItemErrorDrawer = document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message
    };

    if (lineItemErrorDrawer) {
      lineItemErrorDrawer.querySelector('.cart-item__error-text').innerHTML = message
    };

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

class CustomerForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');
    this.fields = this.querySelectorAll('input.required, select.required');
    this.errorFields = this.querySelector('.error-fields');
  }

  enableLoading(){
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');
  }

  disableLoading(){
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopImmediatePropagation();

    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    this.enableLoading();

    const formData = new FormData(this.form);
    let isFormValid = this.validateForm(formData);
    if(!isFormValid) {
      this.disableLoading();
      return;
    }

    window.ci_form_success(this.form)
    this.form.submit();
  }

  validateForm(formData){

    for (const entry of formData.entries()) {
      console.log(entry);
    }
  
    let isFormValid = true;
    let field_errors = [];

    this.fields.forEach(field => {
      switch (field.type) {
        case 'email':
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Email is required'
            });
          } else if (!emailRegex.test(field.value)) {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Please enter a valid email (Format: name@url.com)'
            })
          }
          
          break;
        case 'text':

          var additional_text = ''

          if(field.name == 'address[address1]'){
            var additional_text = '(Format: 2237 Pembina Hwy)'
          } else if(field.name == 'address[zip]'){
            var additional_text = '(Format: R3T 2H1)'
          }

          if (field.name == 'address[zip]') {
            const canadianPostalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            const americanZipCodeRegex = /^\d{5}(-\d{4})?$/;
          
            if (!canadianPostalCodeRegex.test(field.value) && !americanZipCodeRegex.test(field.value)) {
              isFormValid = false; // Mark form as invalid
              field_errors.push({
                field,
                message: 'Please format like postal code (e.g., R3T 2H1 or 12345-6789)'
              });
            }
          }

          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Field is required ' + additional_text
            });
          }
          break;
        case 'tel':
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Phone number is required (Format: (999) 999-9999)'
            });
          }
          break;
        case 'password':
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Password is required'
            });
          }
          break;
        case 'input':
          if (field.value.trim() === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Please Select'
            })
          }
          break;
        case 'select':
          if (field.value === '') {
            isFormValid = false;
            field_errors.push({
              field,
              message: 'Please Select'
            })
          }
          break;
        default:
          break;
      }
    });
      
    let error_fields = this.form.querySelectorAll('.form__message');
    error_fields.forEach(field => field.remove());
    this.errorFields.innerText = '';

    this.fields.forEach((field) => {
      const parentElement = field.parentElement
      parentElement.classList.remove('invalid');
    });

    if(field_errors.length > 0) {

      var header = document.createElement('h3'); 
      header.classList.add('error-header');
      header.innerText = `There are ${field_errors.length} error(s) found in the information you submitted.`
      header.ariaLabel = `There are ${field_errors.length} errors found in the information you submitted.`;
      header.tabIndex = "-1"

      window.ci_form_error(this.form, header.innerText)

      var ulElement = document.createElement('ul');
      field_errors.forEach(function(error) {
        var liElement = document.createElement('li');
        liElement.innerHTML = `<a class="link smooth-scroll" href="#${error.field.id}">${error.field.placeholder}: ${error.message}</a>`; // Customize the format of the error message as needed
        ulElement.appendChild(liElement);
      });

      this.errorFields.appendChild(header);
      this.errorFields.appendChild(ulElement);
    
      // Display new error messages
      field_errors.forEach((error) => {
        const { field, message } = error;
        const parentElement = field.parentElement;
        parentElement.classList.add('invalid');
    
        // Create SVG element
        const svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svgElement.setAttribute("aria-hidden", "true");
        svgElement.setAttribute("focusable", "false");
    
        // Create 'use' element
        const useElement = document.createElementNS("http://www.w3.org/2000/svg", "use");
        useElement.setAttribute("href", "#icon-error");
    
        // Append 'use' element to SVG
        svgElement.appendChild(useElement);
    
        const errorSpan = document.createElement('span');
        errorSpan.classList.add('form__message');
        
        const errorSpanInner = document.createElement('span');
        errorSpanInner.innerText = message
        // Append SVG before error message
        errorSpan.appendChild(svgElement);
        errorSpan.appendChild(errorSpanInner);
    
        // Insert errorSpan after parentElement
        parentElement.insertAdjacentElement('afterend', errorSpan);
      });

      var elementPosition = this.errorFields.getBoundingClientRect().top;
      var headerOffset = document.querySelector('sticky-header').offsetHeight;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset - 15;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });

      this.errorFields.querySelector('.error-header').focus()

      window.initScrollLinks();

    }
  
    return isFormValid;
  
  }

}

customElements.define('customer-form', CustomerForm);

class RedirectTool extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      window.location.href = this.dataset.url;
    }, this.dataset.delay);
  }
}

customElements.define('redirect-tool', RedirectTool);